import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.32 22.767 12 18.343l-6.32 4.424a.75.75 0 0 1-1.18-.614V2.593a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 1.5 1.5v19.56a.75.75 0 0 1-1.18.614M9 1.094v19.349m6-19.349v19.349"
    }, null, -1)
  ]));
}
const interfaceBookmark = { render };
export {
  interfaceBookmark as default,
  render
};
//# sourceMappingURL=interface-bookmark.svg.js.map
